import React from 'react';

interface TableEmptyStateProps {
  /** The plural noun to display, e.g. "orders", "calls", "customers" */
  itemName: string;
}

/**
 * A friendly empty-state illustration shown when a table has no data.
 */
export default function TableEmptyState({ itemName }: TableEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-16 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-gray-100 dark:bg-gray-800">
        <svg
          className="h-8 w-8 text-gray-400 dark:text-gray-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.5}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859m-17.5 0V6.108c0-1.135.845-2.098 1.976-2.192a48.424 48.424 0 0113.548 0c1.131.094 1.976 1.057 1.976 2.192V13.5M2.25 13.5V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.5"
          />
        </svg>
      </div>
      <p className="text-sm font-semibold text-gray-700 dark:text-gray-200">
        You don&apos;t have any {itemName} at the moment
      </p>
      <p className="mt-1 max-w-sm text-xs leading-5 text-gray-400 dark:text-gray-500">
        When {itemName} appear, they&apos;ll show up here.
      </p>
    </div>
  );
}
